module.exports = __webpack_public_path__ + "img/bolt-auto.7893b052.svg";